module.exports = __webpack_public_path__ + "static/media/mutiselect_defult.520c0d9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/mutiselect_defult.svg
// module id = 1655
// module chunks = 0